import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import { password as passwordService } from "../services/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!email) {
      return setError("Please enter your email address");
    }

    if(!/\S+@\S+\.\S+/.test(email)) {
        return setError("Please enter a valid email address");
    }

    try {
        setLoading(true);
      const resp = await passwordService.forgotPassword(email);
      setSuccess(resp.data.message);
      if(resp.status !== 200) {
        setError("Failed to send reset link");
        return;
      }
      // 可选：3 秒后跳转回 login
      setTimeout(() => navigate("/login"), 3000);
    } catch (err: any) {
      setError(err?.response?.data?.message || "Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src="/duitleh.png"
          alt="Duitleh Logo"
          style={{ width: 130, height: "auto", marginBottom: 16 }}
        />
        <Typography component="h1" variant="h5" fontWeight="bold">
          Forgot Password
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mt: 2, width: "100%" }}>
            {error}
          </Alert>
        )}
        {success && (
          <Alert severity="success" sx={{ mt: 2, width: "100%" }}>
            {success}
          </Alert>
        )}

        {!success && (
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ mt: 1, width: "100%" }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "13px",
                },
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                borderRadius: "13px",
                paddingY: 1.2,
                textTransform: 'none',
              }}
              loading={loading}
            >
              Send Reset Link
            </Button>
            <Button
              fullWidth
              variant="text"
              sx={{ 
                textTransform: 'none',
              }}
              onClick={() => navigate('/login')}

            >
                Back to Login
            </Button>
          </Box>
        )}
      </Box>
    </Container>
  );
}
